import { Injectable } from '@angular/core';
import { CommonService } from '../services/Common.service';
import { Observable } from 'rxjs/Observable';
import { EvsAddressService } from '../services/EvsAddress.service';
import { FieldService } from '../services/Field.service';
import { CampaignService } from '../services/Campaign.service';

@Injectable()
export class CommonSettingsService {
  private allOrganize: any = [];
  private allPriority: any = [];
  private allService: any = [];
  private allType: any = [];
  private allStatus: any = [];
  private allCities: any = [];
  private allCampaigns: any = [];
  private allTicketFields: any = [];
  private allUserFields: any = [];
  private userConfigs: any = null;

  async checkNeedRefresh() {
    const user = JSON.parse(localStorage.getItem('User')) || {};
    const settingTenantId = localStorage.getItem('CommonSettingTenantId');
    if (settingTenantId !== user.tenant_id) {
      this.allOrganize = [];
      this.allPriority = [];
      this.allService = [];
      this.allType = [];
      this.allStatus = [];
      this.allCities = [];
      this.allCampaigns = [];
      this.allTicketFields = [];
      this.allUserFields = [];
      localStorage.setItem('CommonSettingTenantId', user.tenant_id);
    }
  }

  constructor(
    private commonService: CommonService,
    private addressService: EvsAddressService,
    private fieldService: FieldService,
    private campaignService: CampaignService
  ) {}

  async setCommonData() {
    const user = JSON.parse(localStorage.getItem('User')) || {};
    const data = await this.commonService.settingCommon({ user_id: user._id }).toPromise();
    if (data.data && !data.error) {
      this.allOrganize = data.data.allOrganize || [];
      this.allPriority = data.data.allPriority || [];
      this.allService = data.data.allService || [];
      this.allType = data.data.allType || [];
      this.allStatus = data.data.status || [];
      this.userConfigs = data.data.userConfig || null;
    }
  }

  async setCities() {
    const data = await this.addressService.getCities().toPromise();
    if (data.data && !data.error) {
      this.allCities = data.data.cities || [];
    }
  }

  async setAllCampaigns() {
    const data = await this.campaignService.all({}).toPromise();
    if (data.data && !data.error) {
      this.allCampaigns = data.data.list || [];
    }
  }

  async setAllTicketFields() {
    const data = await this.fieldService.allField({ target: 'ticket' }).toPromise();
    if (data.data && !data.error) {
      this.allTicketFields = data.data || [];
    }
  }

  async setAllUserFields() {
    const data = await this.fieldService.allField({ target: 'user' }).toPromise();
    if (data.data && !data.error) {
      this.allUserFields = data.data || [];
    }
  }

  async getAllOrganize() {
    await this.checkNeedRefresh();
    if (!this.allOrganize.length) {
      await this.setCommonData();
    }
    return this.allOrganize;
  }

  async getAllPriority() {
    await this.checkNeedRefresh();
    if (!this.allPriority.length) {
      await this.setCommonData();
    }
    return this.allPriority;
  }

  async getAllService() {
    await this.checkNeedRefresh();
    if (!this.allService.length) {
      await this.setCommonData();
    }
    return this.allService;
  }

  async getAllType() {
    await this.checkNeedRefresh();
    if (!this.allType.length) {
      await this.setCommonData();
    }
    return this.allType;
  }

  async getAllStatus() {
    await this.checkNeedRefresh();
    if (!this.allStatus.length) {
      await this.setCommonData();
    }
    return this.allStatus;
  }
  async getUserConfig() {
    await this.setCommonData();
    return this.userConfigs;
  }

  async getAllCities() {
    await this.checkNeedRefresh();
    if (!this.allCities.length) {
      await this.setCities();
    }
    return this.allCities;
  }

  async getAllCampaign() {
    await this.checkNeedRefresh();
    if (!this.allCampaigns.length) {
      await this.setAllCampaigns();
    }
    return this.allCampaigns;
  }

  async getAllTicketFields() {
    await this.checkNeedRefresh();
    if (!this.allTicketFields.length) {
      await this.setAllTicketFields();
    }
    return this.allTicketFields;
  }

  async getAllUserFields() {
    await this.checkNeedRefresh();
    if (!this.allUserFields.length) {
      await this.setAllUserFields();
    }
    return this.allUserFields;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/share-data/common.setting.service.ts